/*
 * moasure-support-hours.js
 * Restates Moasure's phone support hours in the visitor's own time, e.g. "Mon–Fri, 9am–10pm UK time" becomes
 * "Mon–Fri, 4am–5pm EST" for a visitor in New York. Used by the contact page's help cards
 * (sections/contact-help.liquid). Loaded deferred. No dependencies.
 *
 * MARKUP CONTRACT — Liquid writes the hours as quoted, so the line is right before (and without) this script:
 *   <span data-mo-hours="9|22|Europe/London|Mon–Fri">Mon–Fri, 9am–10pm UK time</span>
 *   open hour | close hour (24-hour clock) | the zone they're quoted in (IANA name) | the days wording
 * A blank zone means "show exactly as written".
 *
 * WHY THE BROWSER'S TIME ZONE, NOT AN IP LOOKUP: it's the clock the visitor actually reads, it needs no extra
 * request, and it stays right on a VPN or while travelling.
 *
 * A range that crosses local midnight is deliberately NOT converted ("Mon–Fri, 8pm–9am" would make the days
 * wrong). Those visitors keep the hours as quoted, with the zone named, which is always true.
 *
 * The same conversion runs inline in the LX1 Learning Hub (sections/lx1-support.liquid, on 8 stores); move it
 * onto this file the next time that section is touched.
 */
(function () {
  // The zone's offset from UTC at a given instant, in ms
  function tzOffsetMs(utcMs, tz) {
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(utcMs)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, p.hour === '24' ? 0 : +p.hour, +p.minute, +p.second) - utcMs;
  }

  // The instant the clock in `tz` reads hh:00 on the given date. The second pass gets a day with a
  // daylight-saving change right.
  function instantAt(y, m, d, hh, tz) {
    var wall = Date.UTC(y, m, d, hh, 0, 0);
    return wall - tzOffsetMs(wall - tzOffsetMs(wall, tz), tz);
  }

  // "9am", "10pm", "4:30am"
  function clockLabel(ms, tz) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit', hour12: true })
      .formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    var suffix = (p.dayPeriod || '').toLowerCase().replace(/[^apm]/g, '');
    return p.minute === '00' ? p.hour + suffix : p.hour + ':' + p.minute + suffix;
  }

  function localDay(ms, tz) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' })
      .format(new Date(ms));
  }

  function zoneName(ms, tz) {
    var zone = '';
    new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' })
      .formatToParts(new Date(ms)).forEach(function (x) { if (x.type === 'timeZoneName') zone = x.value; });
    return zone;
  }

  document.querySelectorAll('[data-mo-hours]').forEach(function (el) {
    var cfg = (el.getAttribute('data-mo-hours') || '').split('|');
    var openH = parseInt(cfg[0], 10), closeH = parseInt(cfg[1], 10), srcTz = cfg[2];
    var days = cfg.slice(3).join('|');                   // free text; keep any pipe in it
    if (!srcTz || isNaN(openH) || isNaN(closeH)) return;  // "show exactly as written"
    try {
      var localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!localTz || localTz === srcTz) return;            // already their own clock
      var now = new Date();
      var openMs = instantAt(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), openH, srcTz);
      var closeMs = instantAt(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), closeH, srcTz);
      // must still be one local day, and the same day, or the days wording stops being true
      if (localDay(openMs, localTz) !== localDay(closeMs, localTz)) return;
      if (localDay(openMs, localTz) !== localDay(openMs, srcTz)) return;
      var zone = zoneName(openMs, localTz);
      el.textContent = days + ', ' + clockLabel(openMs, localTz) + '–' + clockLabel(closeMs, localTz) + (zone ? ' ' + zone : '');
    } catch (err) { /* any Intl gap: the quoted hours stay on the page */ }
  });
})();
